import { log } from "./logging"

export const copyToClipBoard = async (text: string): Promise<boolean> => {
    if (navigator.clipboard != null && window.isSecureContext === true) {
        try {
            await navigator.clipboard.writeText(text);
            return Promise.resolve(true);
        } catch (error) {
            log.error("An error occurred while trying to copy from clipboard", error);
            return Promise.resolve(false);
        }
    }

    return Promise.resolve(false);
}